/**
 * Turns the data from the CSV verification into an array that provides
 * the rows for the verification results table.
 * @param {object} verifyWarnings gives all warnings output from verification
 * @param {object} verifyErrors all errors output from verification
 * @returns {array} used to output verification results table
 */
export default function createVerifyRowData({verifyWarnings, verifyErrors}) {
  const warningKeys = [
    'teacherWarnings',
    'studentWarnings',
    'fieldWarnings',
  ]
  const errorKeys = [
    'teacherErrors',
    'studentErrors',
    'fieldErrors',
  ]
  let output = []
  if (!verifyWarnings && !verifyErrors) return []

  // push all errors to output
  errorKeys.forEach(key => {
    if (verifyErrors && verifyErrors[key]) {
      const errors = verifyErrors[key]
      errors.forEach(err => {
        const row = {
          category: 'Error',
          message: err.error,
          rows: err.rows.join(', '),
        }
        output.push(row)
      })
    }
  })
  // push all warning to output
  warningKeys.forEach(key => {
    if (verifyWarnings && verifyWarnings[key]) {
      const warnings = verifyWarnings[key]
      warnings.forEach(warn => {
        const row = {
          category: 'Warning',
          message: warn.warning,
          rows: warn.rows.join(', ')
        }
        output.push(row)
      })
    }
  })

  return output
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createVerifyRowData.js